import React from 'react';
import {Text, View} from 'react-native';

import {Code, Heading, Spacer} from '/component/base/Storybook';

import {CreatePinInput} from '../index';

import {styles} from './PinInput.story.style';

const LightPinInput = () => {
  return (
    <>
      <Spacer size={30} />
      <Heading level={2}>Light PinInput</Heading>
      <Spacer size={30} />
      <Text>
        <Code>CreatePinInput</Code> is used to enter new pin code. During the
        first set of code, he remembers it, and the second time he verifies it
        with the first code input.
      </Text>
      <Spacer size={30} />

      <View style={styles.containerDark}>
        <CreatePinInput
          theme="light"
          textVariant="heading"
          // @ts-expect-error TS(2322): Type 'string' is not assignable to type 'object'.
          createTitle="Please create a new 4-digit PIN."
          // @ts-expect-error TS(2322): Type 'string' is not assignable to type 'object'.
          confirmTitle="Please re-enter a new 4-digit PIN."
        />
      </View>
      <Spacer size={30} />
      <Code>{'<CreatePinInput'}</Code>
      <Code>{' theme="light"'}</Code>
      <Code>{' textVariant="heading"'}</Code>
      <Code>{' createTitle="Please create a new 4-digit PIN."'}</Code>
      <Code>{' confirmTitle="Please re-enter a new 4-digit PIN."'}</Code>
      <Code>{'/>'}</Code>
    </>
  );
};

export default LightPinInput;
